import { getHighestPrivilegedRole } from './user';

export enum Permission {
    EDIT = 'edit',
    DELETE = 'delete',
    DUPLICATE = 'duplicate',
    CREATE = 'create',
    SHARE = 'share',
    EXPORT = 'export',
    DOWNLOAD = 'download',
    ORGANIZATION_SETTINGS_VIEW = 'organization.settings.view',
    ORGANIZATION_SETTINGS_EDIT = 'organization.settings.edit',
    ORGANIZATION_CONFIGURATION_VIEW = 'organization.configuration.view',
    ORGANIZATION_CONFIGURATION_EDIT = 'organization.configuration.edit',
}

const PROJECT_PERMISSIONS: readonly Permission[] = [
    Permission.EDIT,
    Permission.DELETE,
    Permission.DUPLICATE,
    Permission.CREATE,
    Permission.SHARE,
    Permission.EXPORT,
    Permission.DOWNLOAD,
];

const READ_ONLY_PERMISSIONS: readonly Permission[] = [
    Permission.SHARE,
    Permission.EXPORT,
    Permission.DOWNLOAD,
];

const ROLE_PERMISSIONS: Record<string, readonly Permission[]> = {
    admin: PROJECT_PERMISSIONS,
    member: PROJECT_PERMISSIONS,
    reader: READ_ONLY_PERMISSIONS,
    'event-tagger': READ_ONLY_PERMISSIONS,
};

const EMPTY_PERMISSIONS: ReadonlySet<Permission> = new Set<Permission>();

const OTHERS_MAP: Partial<Record<Permission, Permission>> = {};

export function checkPermission(
    permissions: ReadonlySet<Permission>,
    permission: Permission,
    isOwner: boolean,
): boolean {
    if (isOwner && permissions.has(permission)) return true;
    const othersPermission = OTHERS_MAP[permission];
    return !!othersPermission && permissions.has(othersPermission);
}

export function getPermissions(roles: string[]): ReadonlySet<Permission> {
    const role = getHighestPrivilegedRole(roles);
    if (!role) return EMPTY_PERMISSIONS;

    const permissions = ROLE_PERMISSIONS[role];
    if (!permissions) return EMPTY_PERMISSIONS;

    return new Set(permissions);
}
